module.exports = __webpack_public_path__ + "img/saxophone-fire.9207f975.svg";